import { ReactElement, useState } from "react"
import {
    NxButton,
    NxButtonLink,
    NxButtonVariant,
    NxLoader,
    NxTable,
    NxTableColumn
} from '@nextbank/ui-components';
import useAxios from "axios-hooks";
import { useParams } from "react-router";
import { HttpError } from "tools/HttpTypes";
import commandAccessService from 'command/commandAccessService';
import { useCommand } from 'command/CommandService';
import numberWithCommas from "tools/NumberCommaFormatter";

const columns: NxTableColumn<any>[] = [
  {
    title: "No.",
    field: "index",
  },
  {
    title: "Contract no.",
      field: "providerContractNumber",
  },
  {
    title: "Record Type",
    field: "recordType",
  },
  {
    title: "Exposure status",
    field: "exposureStatus",
  },
  {
    title: "Outstanding balance",
    field: "outstandingBalance",
  },
];

const Exposure = (): ReactElement => {
    const { customerId } = useParams<{ customerId: string }>();
    const [{ data: exposure, loading: exposureLoading }, fetchExposures] = useAxios<any, HttpError>(
        `/cocree/customers/${customerId}/exposures`
    );
    const execute = useCommand();
  const [isDeleteExposureLoading, setIsDeleteExposureLoading] = useState<boolean>(false);
    const hasDeleteAccess = commandAccessService.canExecute("DeleteExposure");
    if (exposure) {
      exposure.forEach((obj: any, i: number) => {
        obj.index = i + 1;
        if (obj.recordType === 'OTHER_CREDIT_ACCOMMODATION') {
          obj.recordType = 'Other credit accommodation'
        }
        if (obj.recordType === 'DEBT_AND_EQUITY_INVESTMENT') {
          obj.recordType = "Debt & equity investment"
        }
        if (obj.exposureStatus === 'ACTIVE') {
          obj.exposureStatus = 'Active'
        }
        if (obj.exposureStatus === 'CLOSED_IN_ADVANCE') {
          obj.exposureStatus = 'Closed in advance'
        }
        if (obj.outstandingBalance) {
          obj.outstandingBalance = numberWithCommas(obj?.outstandingBalance, true);
        }
      });
    }
    const OpenExposure = ({ data }: { data: any }): ReactElement => {
        return <NxButtonLink variant={NxButtonVariant.CONTAINED} to={`/customer/${customerId}/cocree/exposure/${data.id}`}>Open</NxButtonLink>;
    }
      
  const DeleteExposure = ({ data }: { data: any }): ReactElement => {
    return (data.reported || !hasDeleteAccess ? <></> : <NxButton variant={NxButtonVariant.DELETE} onClick={async () => {
      try {
        setIsDeleteExposureLoading(true);
        await execute<any, void>({
          name: 'DeleteExposure',
          input: {
            id: data.id
          }
        });

        await fetchExposures()
      } catch(error) {
        console.log(error)
      } finally {
        setIsDeleteExposureLoading(false);
      }
    }}>Delete</NxButton>)
  }
        
    return (
        <>
        {!exposureLoading && !isDeleteExposureLoading ? <div>
                Exposure

                <NxTable columns={columns}
                    rowActions={[OpenExposure, DeleteExposure]}
                    data={exposure} />
            </div> : <NxLoader/>}
        </>
    )
}

export default Exposure;